import React from "react";
import { CheckPicker, Form, InputGroup } from "rsuite";
import styled from "styled-components";

import { debounce } from "utils";
import CustomField from "components/Form/CustomField";
import { Icon } from "components/Icon";


export default ({
    filters,
    referencesLoading,

    onChangeFilters,

    dialerList = []
}) => {
    return (
        <StyledForm
            formDefaultValue={filters}
            onChange={debounce((value) => {
                onChangeFilters(value);
            }, 500)}
        >
            <StyledFormControl
                accepter={CheckPicker}
                placeholder="Dialers"
                data={dialerList}
                labelKey="name"
                valueKey="id"
                name="dialer_id_list"
                errorPlacement="topRight"
                style={{ width: 290 }}
                menuStyle={{ width: 360 }}
                loading={referencesLoading}
                disabled={referencesLoading}
                virtualized
            />
        </StyledForm>
    );
};

const StyledForm = styled(Form)`
    && {
        width: 100%;
        display: flex;
    }
    .rs-form-control-wrapper {
        width: auto;
        margin-right: 20px;
    }
`;

const StyledAddon = styled(InputGroup.Addon)`
    &&&& {
        position: relative;
        padding: 0;
    }
`;

const StyledFormControl = styled(CustomField)`
    && {
        width: 100%;
        min-width: 300px;
        max-width: 320px;
        overflow: hidden;
    }
`;

const StyledFormGroup = styled(Form.Group)`
    && {
        display: flex;
        align-items: center;

        .rs-control-label {
            margin-right: 10px;
            margin-bottom: 0px;
        }
    }
`;